import useSWR from 'swr';
import { useMemo } from 'react';
import { Artist } from 'types';
import api from 'utils/api';

export function useCollabClubArtists() {
  const { data, error, mutate } = useSWR<Artist[]>(
    'collab-club-artists',
    async () => {
      const artists: Artist[] = await api.collabClub.getArtists();
      return artists;
    },
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: true,
      dedupingInterval: 5 * 60 * 1000, // 5 minutes
    }
  );

  // Memoize the artists array to prevent unnecessary re-renders
  const artists = useMemo(() => data || [], [data]);

  return {
    artists,
    isLoading: !data && !error,
    error,
    refetch: mutate,
  };
}
